import React from "react";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import NumberFormat from 'react-number-format';
import { withStyles } from '@material-ui/core/styles';
import {NavLink} from "react-router-dom";
import LastUpdatedDate from '../components/LastUpdatedDate'
import AccountAvatars from '../components/AccountAvatars'
import Moment from 'react-moment';
import PriorBalanceComparison from '../components/PriorBalanceComparison'
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';

const styles = theme => ({
  cellLessPadding: {
    paddingRight: 0,
    paddingLeft: 8
  },
  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  unstyledLink: {
    color: 'inherit',
    textDecoration: 'inherit',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem'
    },
  },
  balance: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem'
    },
  },
  lastUpdated: {
    fontSize: '0.7rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem'
    },
  },
  priorBalance: {
    fontSize: '0.7rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem'
    },
  },
  negativeCell : {
    color: 'red',
  },
  closedDate: {
    fontStyle: "italic",
    color: "gray",
    fontSize: '0.7rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem'
    },
  },
  accountType: {
    fontStyle: "italic",
    color: "gray",
    fontSize: '0.7rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem'
    },
  },
  alignRight: {
    textAlign: "right"
  }  
});

const NetWorthTableCategoryRow = (props) => {
  const { classes } = props;
  const [expandCategory, setExpandCategory] = React.useState(false)


  const { subtype_id,
    accountTypes,
    account_subtypes,
    accounts,
    show_closed,
    show_zero,
    comp_period,
    categories,
  startDate,
  category_id } = props

  const filtered_account_ids = account_subtypes[subtype_id].account_ids.filter((account_id) => accounts[account_id].account_category_id == category_id && (show_closed || !accounts[account_id].closed_date) && (show_zero || accounts[account_id].latest_balance !== 0))


  const handleClick = () => {
    setExpandCategory(!expandCategory);
  };


  return (
                    <React.Fragment>
                    <TableRow key={category_id} >
                      <TableCell className={classes.cellLessPadding} component="th" scope="row" onClick={handleClick}>
                        <IconButton>{expandCategory ? <ExpandLess /> : <ExpandMore />}</IconButton>
                      </TableCell>
                      <TableCell className={classes.cellLessPadding} component="th" scope="row" >
                        {accountTypes[subtype_id].account_categories[category_id] && accountTypes[subtype_id].account_categories[category_id].account_category_name} 
                        <div className={classes.accountType}>
                          {filtered_account_ids.length} accounts
                        </div>
                      </TableCell>
                      <TableCell className={classes.cellLessPadding} align="right" >
                        <div className={classes.balance}>
                          {categories[category_id].category_total >= 0 &&
                            <NumberFormat value={categories[category_id].category_total} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                          }
                          {categories[category_id].category_total < 0 &&
                            <NumberFormat className={classes.negativeCell} value={categories[category_id].category_total} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                          }
                        </div>
                        <div className={classes.priorBalance}>
                          {comp_period > -1 &&
                            <PriorBalanceComparison days={comp_period} startDate={startDate} account_ids={categories[category_id].account_ids} />
                          }
                        </div>   
                      </TableCell>
                    </TableRow>
                    <React.Fragment>

                      {expandCategory && filtered_account_ids.map(account_id => (
                      <TableRow key={account_id} >
                        <TableCell className={classes.cellLessPadding} component="th" scope="row" >
                          <AccountAvatars account={accounts[account_id]} showUser={true} />
                        </TableCell>
                        <TableCell className={classes.cellLessPadding} component="th" scope="row" >                        
                        <NavLink to={"/accountdetail/" + account_id} className={classes.unstyledLink}>
                          {accounts[account_id].name}
                        </NavLink>
                        <div className={classes.accountType}>
                          {accounts[account_id].account_category_id && accountTypes[accounts[account_id].account_subtype_id].account_categories[accounts[account_id].account_category_id].account_category_name} 
                        </div>
                        </TableCell>
                        <TableCell className={classes.cellLessPadding} align="right">
                            <div className={classes.balance}>
                            { accounts[account_id].latest_balance >= 0 &&
                              <NumberFormat value={accounts[account_id].latest_balance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                            }
                            { accounts[account_id].latest_balance < 0 &&
                              <NumberFormat className={classes.negativeCell} value={accounts[account_id].latest_balance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                            }
                          </div>
                          <div className={classes.priorBalance}>
                            {comp_period > -1 && 
                              <PriorBalanceComparison days={comp_period} startDate={startDate} account_ids={[account_id]} />
                            }
                          </div>                      
                          <div className={classes.lastUpdated}>
                              {!accounts[account_id].closed_date && 
                                <LastUpdatedDate last_updated_date={accounts[account_id].balance_last_updated} />
                              }
                              {accounts[account_id].closed_date &&
                                <span className={classes.closedDate}>Closed <Moment format="MMM YYYY">{accounts[account_id].closed_date}</Moment></span>
                              }
                          </div>               
                        </TableCell>

                      </TableRow>
                    ))}
                    </React.Fragment>
                    </React.Fragment>           
  );
};

export default withStyles(styles)(NetWorthTableCategoryRow);